import { put, select, takeLatest } from "redux-saga/effects";
import { logOut } from "../../../auth/Login/redux/LoginAction";
import getDependency from "../../../../redux/utils/getDependency";
import UserRepository from "../../../../rest/user/UserRepository";
import BenchmarkRepository from "../../../../rest/benchmark/BenchmarkRepository";
import getErrorMessage from "../../../../errors/messages/getErrorMessage";
import AuthService from "../../../auth/Login/service/AuthService";
import CurrentUserDetails from "../model/CurrentUserDetails";
import {
  CurrentUserChangePasswordAction,
  currentUserChangePasswordFailure,
  CurrentUserDetailsUpdatedAction,
  currentUserLoaded,
  currentUserLoadError,
  currentUserPasswordChanged,
  currentUserUpdateError,
  CURRENT_USER_CHANGE_PASSWORD_TYPE,
  CURRENT_USER_UPDATED_TYPE,
  LoadCurrentUserAction,
  CurrentUserChangePasswordFailureAction,
  LOAD_CURRENT_USER_TYPE,
  LINK_BENCHMARK_ENGINEER_TYPE,
  UNLINK_BENCHMARK_ENGINEER_TYPE,
  LinkBenchmarkEngineerAction,
  benchmarkEngineerLinked,
  linkBenchmarkEngineerError,
  benchmarkEngineerUnlinked,
  unlinkBenchmarkEngineerError,
  TOGGLE_TIME_PERIOD_VIEW_TYPE,
  ToggleTimePeriodViewAction,
} from "./CurrentUserAction";
import RootState from "../../../../redux/RootState";

function* currentUserSagas() {
  yield takeLatest(LOAD_CURRENT_USER_TYPE, getCurrentUser);
  yield takeLatest(CURRENT_USER_UPDATED_TYPE, updateCurrentUserAction);
  yield takeLatest(CURRENT_USER_CHANGE_PASSWORD_TYPE, changeCurrentUserPassword);
  yield takeLatest(LINK_BENCHMARK_ENGINEER_TYPE, linkBenchmarkEngineer);
  yield takeLatest(UNLINK_BENCHMARK_ENGINEER_TYPE, unlinkBenchmarkEngineer);
  yield takeLatest(TOGGLE_TIME_PERIOD_VIEW_TYPE, toggleTimePeriodView);
}

export function* updateCurrentUserAction(action: CurrentUserDetailsUpdatedAction) {
    try {
        const userRepo: UserRepository = yield getDependency("userRepository");

        const updatedUser: CurrentUserDetails = yield userRepo.updateUserDetails(
            action.user,
            action.user.onboarding
        );
        yield put(currentUserLoaded(updatedUser));
    } catch (e) {
        const message = getErrorMessage(e, undefined);
        yield put(currentUserUpdateError(message));
    }
}

export function* changeCurrentUserPassword(action: CurrentUserChangePasswordAction) {
    try {
        const authService: AuthService = yield getDependency("authService");

        yield authService.changePassword(
            action.password.old_password,
            action.password.new_password
        );

    yield put(currentUserPasswordChanged(action.message));
    yield put(logOut());
  } catch (e) {
    yield put(currentUserChangePasswordFailure((e as any).message));
  }
}

export function* getCurrentUser(action: LoadCurrentUserAction) {
    try {
        const userRepo: UserRepository = yield getDependency("userRepository");
        const me: CurrentUserDetails = yield userRepo.getMe();

        yield put(currentUserLoaded(me));
    } catch (e) {
        const message = getErrorMessage(e, undefined);
        yield put(currentUserLoadError(message));
    }
}

export function* linkBenchmarkEngineer(action: LinkBenchmarkEngineerAction) {
  try {
    const benchmarkRepo: BenchmarkRepository = yield getDependency("benchmarkRepository");

    const updatedUser: CurrentUserDetails = yield benchmarkRepo.attachEngineer(
      action.engineerUuid
    );

    yield put(benchmarkEngineerLinked(updatedUser));
  } catch (e) {
    const message = getErrorMessage(e, "Failed to link Benchmark account");
    yield put(linkBenchmarkEngineerError(message));
  }
}

export function* unlinkBenchmarkEngineer() {
  try {
    const benchmarkRepo: BenchmarkRepository = yield getDependency("benchmarkRepository");

    const updatedUser: CurrentUserDetails = yield benchmarkRepo.detachEngineer();

    yield put(benchmarkEngineerUnlinked(updatedUser));
  } catch (e) {
    const message = getErrorMessage(e, "Failed to unlink Benchmark account");
    yield put(unlinkBenchmarkEngineerError(message));
  }
}

export function* toggleTimePeriodView(action: ToggleTimePeriodViewAction) {
  try {
    const rootState: RootState = yield select();
    const currentUser = rootState.currentUser.user;
    if (!currentUser) {
      throw new Error("No current user");
    }

    const userRepo: UserRepository = yield getDependency("userRepository");
    const updatedUser: CurrentUserDetails = yield userRepo.updateUserDetails(
      {
        ...currentUser,
        toggle_view_tests: action.showRecentOnly,
      },
      currentUser.onboarding
    );

    yield put(currentUserLoaded(updatedUser));
  } catch (e) {
    const message = getErrorMessage(e, undefined);
    yield put(currentUserUpdateError(message));
  }
}

export default currentUserSagas;
